module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDggMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjU4OTg0NCAxMC41OUw1LjE2OTg0IDZMMC41ODk4NDQgMS40MUwxLjk5OTg0IDBMNy45OTk4NCA2TDEuOTk5ODQgMTJMMC41ODk4NDQgMTAuNTlaIiBmaWxsPSIjQjQxQjNFIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_menu_arrow_right.svg
// module id = Zo3j
// module chunks = 1